module.exports = __webpack_public_path__ + "img/operation.b1a0f256.svg";